import { render, staticRenderFns } from "./ProductSlide.vue?vue&type=template&id=1cb65bc4&"
import script from "./ProductSlide.vue?vue&type=script&lang=js&"
export * from "./ProductSlide.vue?vue&type=script&lang=js&"
import style0 from "./ProductSlide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports